<script>
    import gsap from 'gsap';
    import DrawSVGPlugin from 'gsap/DrawSVGPlugin';
    import {onMount, onDestroy} from "svelte";

    gsap.registerPlugin(DrawSVGPlugin);

    let displayNum = 0;
    let displayNumTwo = 0;

    function interpolate(start, target, durationMS) {
        if (start === target) {
            return;
        }

        const steps = target - start;
        const frameDuration = durationMS / steps;
        const newStart = start + 1;

        displayNum = newStart;

        setTimeout(() => interpolate(newStart, target, durationMS - frameDuration), frameDuration);
    }

    function interpolateTwo(start, target, durationMS) {
        if (start === target) {
            return;
        }

        const steps = target - start;
        const frameDuration = durationMS / steps;
        const newStart = start + 1;

        displayNumTwo = newStart;

        setTimeout(() => interpolateTwo(newStart, target, durationMS - frameDuration), frameDuration);
    }

    let drawLine;
    let tl = gsap.timeline();
    let svgElement;


    onMount(() => {
        const paths = Array.from(svgElement.getElementsByTagName('path'));

        tl.fromTo(paths, {
            drawSVG: "100% 100%",
            transformOrigin: 'center center',
        }, {drawSVG: "100% 0%",
            duration: 1,
            onStart: () => {
                interpolate(0, 77, 1000);
                interpolateTwo(0, 40, 1000)
            },
        }, 0);

        tl.play();
    });

    onDestroy(() => {
        tl.clear();
        tl = null;
    })
</script>

<svg xmlns="http://www.w3.org/2000/svg" width="100%" viewBox="0 0 380 678" bind:this={svgElement}>
    <defs>
        <clipPath id="clip-path">
            <rect id="Rectangle_540" data-name="Rectangle 540" width="300.308" height="142.095" fill="none"/>
        </clipPath>
    </defs>
    <rect id="Rectangle_864" data-name="Rectangle 864" width="380" height="678"/>
    <text id="Tenders_happen_more_often_so_partners_have_to_keep_proving_their_value" data-name="Tenders happen more often, so partners have to keep proving their value" transform="translate(40 145)" fill="#fff" font-size="24" font-family="Metric"><tspan x="0" y="18">Tenders happen more </tspan><tspan x="0" y="46">often, so partners have to </tspan><tspan x="0" y="74">keep proving their value</tspan></text>
    <text id="of_companies_re-tender_at_least_once_every_two_years" data-name="of companies re-tender at least once every two years" transform="translate(40 415)" fill="#fff" font-size="24" font-family="Metric"><tspan x="0" y="18">of companies </tspan><tspan x="0" y="46">re-tender at </tspan><tspan x="0" y="74">least once </tspan><tspan x="0" y="102">every two </tspan><tspan x="0" y="130">years</tspan></text>
    <text id="_do_it_annually" data-name=" do it annually" transform="translate(207 415)" fill="#fff" font-size="24" font-family="Metric"><tspan x="0" y="18" xml:space="preserve"> do it annually</tspan></text>
    <text id="What_s_new_about_how_companies_select_strategic_partners_" data-name="What’s new about how
companies select
strategic partners?
" transform="translate(40 50.446)" fill="#fcd0b1" font-size="24" font-family="Metric"><tspan x="0" y="0">What’s new about how </tspan><tspan x="0" y="28">companies select </tspan><tspan x="0" y="56">strategic partners? </tspan><tspan font-family="Metric-Semibold" font-weight="600"><tspan x="0" y="84"></tspan></tspan></text>
    <text id="_77_" data-name="77%" transform="translate(53 300)" fill="#fff" font-size="60" font-family="Metric-Bold, Metric" font-weight="700"><tspan x="6.956" y="46">{displayNum}%</tspan></text>
    <text id="_40_" data-name="40%" transform="translate(207 300)" fill="#fff" font-size="60" font-family="Metric-Bold, Metric" font-weight="700"><tspan x="6.956" y="46">{displayNumTwo}%</tspan></text>
    <g id="Group_1100" data-name="Group 1100" transform="translate(40 256)">
        <g id="Group_1099" data-name="Group 1099" clip-path="url(#clip-path)">
            <path id="Path_14516" data-name="Path 14516" d="M69.065,4.966A68.065,68.065,0,1,1,1,73.031,75.829,75.829,0,0,1,1.692,62.6" fill="none" stroke="#008ed2" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
            <path id="Path_14517" data-name="Path 14517" d="M65.377,4.643a3.8,3.8,0,1,1,3.8,3.8,3.8,3.8,0,0,1-3.8-3.8" fill="#fff"/>
            <path id="Path_14518" data-name="Path 14518" d="M65.377,4.643a3.8,3.8,0,1,1,3.8,3.8A3.8,3.8,0,0,1,65.377,4.643Z" fill="none" stroke="#100f0c" stroke-miterlimit="10" stroke-width="1.687"/>
            <path id="Path_14519" data-name="Path 14519" d="M231.243,4.966A68.069,68.069,0,0,1,270.7,128.5" fill="none" stroke="#008ed2" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
            <path id="Path_14520" data-name="Path 14520" d="M227.555,4.643a3.8,3.8,0,1,1,3.8,3.8,3.8,3.8,0,0,1-3.8-3.8" fill="#fff"/>
            <path id="Path_14521" data-name="Path 14521" d="M227.555,4.643a3.8,3.8,0,1,1,3.8,3.8A3.8,3.8,0,0,1,227.555,4.643Z" fill="none" stroke="#100f0c" stroke-miterlimit="10" stroke-width="1.687"/>
        </g>
    </g>
</svg>
